import { atom } from 'jotai';

import { IMultisigTransaction } from '../../utils/transform-multisig-transaction';

export const safeTransactionsAtom = atom<IMultisigTransaction[]>([]);
export const nextNonceAtom = atom(-1);
export const nextExecutedNonceAtom = atom(-1);
